import React, { useState } from 'react';
import { useQuery } from 'react-query';
import { endpoints, fetcher } from 'services';
import { INIT_PAGESIZE } from 'commons/constants';

const useProjectAskSelectList = (company_srl: number, pageNo: number, pageSize: number, search: string, pm: string, lecture_type: string | undefined, lecture_subject: string | undefined) => {
  /* ======================================================
   * state
   * ====================================================== */
  const [askList, setAskList] = useState<ProjectAskSelectListDto[]>();
  const [searchResult, setSearchResult] = useState({ pageNo: 0, pageSize: INIT_PAGESIZE, totalCount: 0 });

  /* ======================================================
   * hooks
   * ====================================================== */
  const { } = useQuery(
    [endpoints.project.ask.list, company_srl, pageNo, search, pm, lecture_type, lecture_subject],
    () =>
      fetcher.project.postProjectAskList({
        pageNo: pageNo || 1,
        pageSize: pageSize || 10,
        company: company_srl.toString(),
        searchValue: search || '',  
        pm: pm || '',  
        lecture_type: lecture_type || '',  
        lecture_subject: lecture_subject || '', 
      }),
    {
      onSuccess: (res: ProjectAskListResDto) => {
        switch (res.code) {
          case 200:
            setAskList(res.result?.list);
            setSearchResult({
              pageNo: res.result?.pageNo || 1,
              pageSize: res.result?.pageSize || INIT_PAGESIZE,
              totalCount: res.result?.totalCount || 0,
            });
            break;
          case 400:
          default:
            break;
        }
      },
    },
  );


  return { askList, searchResult };
};

export default useProjectAskSelectList;
